module.exports = __webpack_public_path__ + "img/erweima.da8746cc.png";